// extracted by mini-css-extract-plugin
export var boldText = "_3f-4";
export var checkboxContainer = "_3f-6";
export var closeIcon = "_3f-g";
export var container = "_3f-0";
export var drawer = "_3f-8";
export var drawerContent = "_3f-9";
export var extraSmallText = "_3f-5";
export var fulfillmentGroupTable = "_3f-e";
export var largeText = "_3f-3";
export var loadingSpinnerContainer = "_3f-h";
export var mediumText = "_3f-2";
export var narrow = "_3f-f";
export var notificationLink = "_3f-j";
export var packageCheckIconContainer = "_3f-7";
export var slideoutHeaderContainer = "_3f-a";
export var slideoutModal = "_3f-c";
export var stickyHeaderWrapper = "_3f-b";
export var table = "_3f-i";
export var tableContainer = "_3f-d";
export var tertiaryText = "_3f-1";